export const validateCode = (event: any, length: number) => {
  return event.target.value.replace(/\D/g, '').slice(0, length);
};
